// src/components/ui/Modal/ModalHeader.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useResponsive } from '@/hooks/useResponsive';
import styles from './ModalHeader.module.css';

export interface ModalHeaderProps {
  children: React.ReactNode;
  onClose?: () => void;
  className?: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  children,
  onClose,
  className = ''
}) => {
  // Используем хук для переводов
  const { t } = useTranslation('ui', { keyPrefix: 'modal' });
  
  // Используем хук адаптивности для определения типа устройства
  const { isMobile } = useResponsive();
  
  return (
    <div className={`${styles.header} ${isMobile ? styles.headerMobile : ''} ${className}`}>
      <div className={`${styles.title} ${isMobile ? styles.titleMobile : ''}`}>
        {children}
      </div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className={`${styles.closeButton} ${isMobile ? styles.closeButtonMobile : ''}`}
          aria-label={t('close', 'Закрыть')}
        >
          <X className={`${styles.closeIcon} ${isMobile ? styles.closeIconMobile : ''}`} />
        </button>
      )}
    </div>
  );
};

export default ModalHeader;